<template>
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li
        v-for="(breadcrumb, idx) in breadcrumbList"
        :key="idx"
        class="breadcrumb-item"
        :class="{'active': idx === breadcrumbList.length - 1}"
        :aria-current="idx === breadcrumbList.length - 1 ? 'page' : null"
      >
        <a
          v-if="breadcrumb.to && idx !== breadcrumbList.length - 1"
          href="#"
          @click.prevent="routeTo(idx)"
        >
          {{ breadcrumb.text }}
        </a>
        <span v-else>{{ breadcrumb.text }}</span>
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  name: 'Breadcrumb',
  data() {
    return {
      breadcrumbList: []
    }
  },
  mounted() { 
    this.updateList() 
  },
  watch: { 
    '$route'() { 
      this.updateList() 
    } 
  },
  methods: {
    routeTo(pRouteTo) {
      if (this.breadcrumbList[pRouteTo].to) {
        this.$router.push(this.breadcrumbList[pRouteTo].to)
      }
    },
    updateList() { 
      this.breadcrumbList = this.$route.meta.breadCrumbs || []
    }
  }
}
</script>

<style scoped>
.breadcrumb {
  background-color: transparent;
  padding: 0.5rem 1rem;
  margin-bottom: 1rem;
}

@media (max-width: 767px) {
  .breadcrumb-item:not(:last-child) {
    display: none;
  }
}
</style>
